import * as React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { produce } from 'immer';
import { VerificationService,
         StudentPersonalInfoViewModel,
         logger,
         VerificationStepsEnum,
         getMaxReviewTime,
} from '@sheerid/jslib';

const DOC_UPLOAD_POLL_DURATION = 20000;
const SSO_POLL_DURATION = 5000;

const defaultDocUploadSubtitle = 'SheerID is reviewing your documents, to confirm your status.';

const defaultDocUploadSubtitle2 = 'We will notify you via email of the outcome.';

const defaultSSOSubtitle = "Please sign in to your school's web portal. It will open in a new tab.";

const defaultSSOSubtitle2 = "Can't sign in to your school?";

interface StepPendingProps {
    verificationService: VerificationService;
    intl: any;
}

const StepPending = ({ verificationService, intl }: StepPendingProps) => {
    const programId = verificationService.programId;
    const viewModel = verificationService.viewModel;
    const previousViewModel = (verificationService.previousViewModel as StudentPersonalInfoViewModel) || undefined;
    const previousVerificationResponse = verificationService.previousVerificationResponse || undefined;
    const verificationId = verificationService.verificationResponse.verificationId;

    const isPreviousStepSSO = (): boolean => {
        if (previousVerificationResponse && previousVerificationResponse.currentStep === VerificationStepsEnum.sso) {
            return true;
        }
        return false;
    };

    const cancelSSOStep = () => {
        const nextState = produce(viewModel, () => {});
        logger.info('StepSSOComponent submitting cancel request');
        clearTimeout(timeout);
        verificationService.submitStep(VerificationStepsEnum.sso, nextState, verificationService.previousVerificationResponse);
    };

    const pollForVerificationServiceUpdates = () => setTimeout(
        () => {
            verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse, previousViewModel);
        },
        isPreviousStepSSO() ? SSO_POLL_DURATION : DOC_UPLOAD_POLL_DURATION,
    );

    const timeout = pollForVerificationServiceUpdates();

    return (
        <div id="sid-step-pending" className="sid-l-container">
            {
                isPreviousStepSSO() ?
                    <div className="sid-header sid-l-horz-center">
                        <div className="sid-l-horz-center">
                        </div>
                        <div className="sid-verification_title sid-l-horz-center sid-l-space-top-md">
                            <FormattedHTMLMessage id="step.docUpload.verificationTitle" defaultMessage="STUDENT VERIFICATION" />
                        </div>
                        <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                            <FormattedHTMLMessage id="step.sso.title" defaultMessage="Verify using your school credentials" />
                        </div>
                        <div className="sid-header__subtitle-one">
                            <FormattedHTMLMessage
                                id="step.sso.subtitle"
                                defaultMessage={defaultSSOSubtitle}
                            />
                        </div>
                        <div className="sid-l-space-top-xl" />
                        <div className="sid-header__subtitle-two sid-h-small-text sid-l-space-top-md">
                            <FormattedHTMLMessage
                                id="step.sso.subtitle2"
                                defaultMessage={defaultSSOSubtitle2}
                            />
                            <div className="sid-form-region sid-submit-wrapper sid-l-space-top-md">
                                <button
                                    onClick={cancelSSOStep}
                                    type="submit"
                                    className="sid-btn sid-btn--dark sid-l-full-width"
                                    aria-label="submit"
                                >
                                    <FormattedHTMLMessage id="step.sso.cancel" defaultMessage="Upload Proof of Enrollment" />
                                </button>
                            </div>
                        </div>
                        <div className="sid-l-space-top-xl" />
                    </div>
                :
                    <div className="sid-header sid-l-horz-center">
                        <div className="sid-l-horz-center">
                        </div>
                        <div className="sid-verification_title sid-l-horz-center sid-l-space-top-md">
                            <FormattedHTMLMessage id="step.docUpload.verificationTitle" defaultMessage="STUDENT VERIFICATION" />
                        </div>
                        <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                            <FormattedHTMLMessage id="step.pending.title" defaultMessage="Processing" />
                        </div>
                        <div className="sid-header__subtitle-one">
                            <FormattedHTMLMessage
                                id="step.pending.subtitle"
                                defaultMessage={defaultDocUploadSubtitle}
                                values={{
                                    maxReviewTime: intl.formatMessage({
                                        id: `dateTime.${getMaxReviewTime(verificationService.programTheme)}`,
                                        default: '2 hours',
                                    }),
                                }}
                            />
                        </div>
                        <div className="sid-header__subtitle-two sid-l-space-top-md">
                            <FormattedHTMLMessage
                                id="step.pending.subtitle2"
                                defaultMessage={defaultDocUploadSubtitle2}
                            />
                        </div>
                        <div className="sid-l-space-top-xl" />
                    </div>
            }
        </div>
    );
};

export const StepPendingComponent = injectIntl(StepPending);
